import React from 'react'

export const PageHeading: React.FC<{heading: string}> = ({heading}) => {
  return (
    <h1 className="text-[32px] leading-[26px] text-primary font-semibold py-[35px] " >
      {heading}
    </h1>
  )
}
